import {
  Injectable
} from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import {
  CommonService
} from './common.service';
import {
  GlobalSettings
} from './global.settings';
import Utils from './utils';
@Injectable()
export class AuthGuardService implements CanActivate {
  orgCode = '';
  orgId = '';

  constructor(public router: Router, private service: CommonService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (sessionStorage.getItem('current_url') && sessionStorage.getItem('current_url') !== state.url) {
      return false;
    } else {
      const cookieObj = document.cookie;
      console.log('####', sessionStorage.getItem('current_url'), '#### else', state.url, Utils.getCookie('central_auth_token'));
      if (Utils.getCookie('central_auth_token') || (cookieObj.indexOf('SSOUser') !== -1 && cookieObj.indexOf('central_auth_token') !== -1)) {
        return true;
      } else {
        const org = state.url.split('/')[Utils.orgCodeIndex];
        console.log('############', org);
        localStorage.clear();
        localStorage.setItem('orgDetails', JSON.stringify({
          'orgCode': org,
          'orgId': '',
          'orgLogoPath': ''
        }));
        this.setOrgId(org);
        return false;
      }
    }
  }

  setOrgId(org_code) {

    const url = GlobalSettings.GET_ORGANIZATION_CODE + '/' + org_code;
    this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
      this.orgCode = res['org_code'];
      this.orgId = res['organization_id'];
      if (org_code === this.orgCode) {
        localStorage.setItem('orgDetails', JSON.stringify({
          'orgCode': this.orgCode,
          'orgId': this.orgId,
          'orgLogoPath': res['branding_logo'] ? res['branding_logo'] : ''
        }));
      }
      console.log('this.orgCode', this.orgCode, org_code)
      this.router.navigate([Utils.getURLPrefix(this.orgCode)]);
    }).catch((err: any) => {
      console.log('Error in get org service auth guard', url);
    });
  }
}
